<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">
              Operating profit/(loss) - {{commonService.headerName}}
            </h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">
              Close Accounts
            </button>
          </div>
        </div>
      </div>
      <hr />
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <div class="col-12">
            <!--<h5 class="fw-bolder font-size-16">
              Operating profit/(loss)
            </h5>-->
            <p class="text-dark">
              Please enter notes on operating profit/(loss). If you have made a profit on disposal of fixed assets,
              this should be entered as a negative number, please pre-fix the number with a minus sign.
            </p>
          </div>
        </div>
        <form name="Operatingprofirorloss" [formGroup]="Operatingprofirorloss">
          <div class="row">
            <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12 ">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <h6 class="m-t-5 fw-bolder"></h6>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                              <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                              <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                 </div>
                <div class="col-12 ps-0 ps-lg-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Depreciation - owned assets</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective placeholder="" formControlName="OPLDepreciationExpensePropertyPlantEquipment" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLDepreciationExpensePropertyPlantEquipment_LY" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Depreciation - assets on hire purchase contract</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLAccumulatedDepreciationImpairmentPropertyPlantEquipment" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLAccumulatedDepreciationImpairmentPropertyPlantEquipment_LY" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Amortisation of goodwill</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue " [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLDepreciationPropertyPlantEquipmentIntangibleAssetsCriticalEstimatesJudgements" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLDepreciationPropertyPlantEquipmentIntangibleAssetsCriticalEstimatesJudgements_LY" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Amortisation of intangible fixed assets</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLAmortisationExpenseIntangibleAssets" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLAmortisationExpenseIntangibleAssets_LY" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Profit/(Loss) on disposal of fixed assets</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLdisposalfixesassets" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLdisposalfixesassets_LY" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Auditors remuneration</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLTotalFeesToAuditors" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLTotalFeesToAuditors_LY" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                            <label class="m-t-5 font-weight-600">Operating lease rentals</label>
                          </div>
                          <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="row">
                              <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLTotalOperatingLeasePayments" />
                                </div>
                              </div>
                              <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective formControlName="OPLTotalOperatingLeasePayments_LY" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                          <div class="row">
                            <!--<div class="col-12 col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="mb-5">
      </div>
      <div class="mb-4">
        <label>Depreciation - owned assets</label>
      </div>
      <div class="mb-4">
        <label>Depreciation - assets on hire purchase contract</label>
      </div>
      <div class="mb-4">
        <label>Amortisation of goodwill</label>
      </div>
      <div class="mb-4">
        <label>Amortisation of intangible fixed assets</label>
      </div>
      <div class="mb-4">
        <label>Profit/(Loss) on disposal of fixed assets</label>
      </div>
      <div class="mb-4">
        <label>Auditors remuneration</label>
      </div>
      <div class="mb-4">
        <label>Operating lease rentals</label>
      </div>
    </div>
    <div class="col-12 col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="mb-2 text-center">
        <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
        <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective placeholder="" formControlName="OPLDepreciationExpensePropertyPlantEquipment" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLAccumulatedDepreciationImpairmentPropertyPlantEquipment" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLDepreciationPropertyPlantEquipmentIntangibleAssetsCriticalEstimatesJudgements" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLAmortisationExpenseIntangibleAssets" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLDisposalFixesassets" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLTotalFeesToAuditors" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLTotalOperatingLeasePayments" />
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngIf="commonService.showControl==true">
      <div class="mb-2 text-center">
        <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
        <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLDepreciationExpensePropertyPlantEquipment_LY" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLAccumulatedDepreciationImpairmentPropertyPlantEquipment_LY" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLDepreciationPropertyPlantEquipmentIntangibleAssetsCriticalEstimatesJudgements_LY" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLAmortisationExpenseIntangibleAssets_LY" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLDisposalFixesassets_LY" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLTotalFeesToAuditors_LY" />
        </div>
      </div>
      <div class="mb-2">
        <div class="input-group">
          <div class="input-group-text ">£</div>
          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="OPLTotalOperatingLeasePayments_LY" />
        </div>
      </div>
    </div>-->
                          </div>
                        </div>
              </div>
            </div>

            <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-3">
              <label>
                Please enter any additional information in the field below.
              </label>
              <div class="mb-3">
                <textarea class="form-control string" [appTooltip]="showBubbledata" appNumberdirective maxlength="4000" formControlName="ExceptionalItemsFreeøtextComment" rows="6" required></textarea>
              </div>
            </div>
            <!--<div class="col-12">
              <div class="bg-lightheme p-2">
                <p class="mb-0 pb-0"><b>Note:</b><span>  Please enter notes on operating profit/(loss). If you have made a profit on disposal of fixed assets,
    this should be entered as a negative number, please pre-fix the number with a minus sign.</span></p>
              </div>
            </div>-->
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="Save()">Next</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
